import Module from "./apps/PurchaseModule.svelte";
import { mount } from "svelte";
window.PurchaseModule = function (options) {
    return mount(Module, options);
};
